import React from 'react';

import Constants from 'lib/Constants';
import StorytellerUtils from 'lib/StorytellerUtils';
import { EnvironmentFactory } from 'StorytellerEnvironment';
import { I18n } from 'common/i18n';
import { type ReactRendererProps } from '../shared/ComponentRegistry';

interface EmbeddedHtmlValue {
  documentId?: string;
  layout: {
    height: number;
  };
  title?: string;
  url: string;
}

export const resizableProps = () => {
  return {
    resizeSupported: true,
    resizeOptions: {
      minHeight: Constants.MINIMUM_COMPONENT_HEIGHTS_PX.HTMLEMBED,
    },
  };
};

export const ComponentEmbeddedHtml = ({ componentData }: ReactRendererProps) => {
  const Environment = EnvironmentFactory();
  const value = componentData.value as EmbeddedHtmlValue;
  const typeClasses = StorytellerUtils.typeToClassesForComponentType(componentData.type);

  if (!value?.url) {
    return null;
  }

  return (
    <div className={`component ${typeClasses}`}>
      <iframe
        src={value.url}
        title={value.title || I18n.t('editor.asset_selector.embed_code.iframe_title')}
        height={value.layout.height}
        data-document-id={value.documentId}
        sandbox={String(Environment.EMBED_CODE_SANDBOX_IFRAME_ALLOWANCES ?? '')}
      />
    </div>
  );
};
